import { type ApplicationInCustomerDetailsFragment } from '../../../api/fragments/ApplicationInCustomerDetails';
import { getApplicationReferenceLink } from '../../admin/CustomerListPage/CustomerList';
import { eventAdminPath } from '../ApplicationDetailsPage/standard/ApplicationTab/ReferenceApplicationField';
import JourneySteps from './JourneySteps';

export type CustomerJourneyStepProps = { application: ApplicationInCustomerDetailsFragment };
const CustomerJourneyStep = ({ application }: CustomerJourneyStepProps) => (
    <JourneySteps
        application={application}
        getApplicationReferenceLink={getApplicationReferenceLink}
        getEventDetail={eventAdminPath}
    />
);

export default CustomerJourneyStep;
